import { List } from 'foundations-components/transitional/components/List';
import { AssignPlaylistButton } from './AssignPlaylistButton';
import PlaylistAssignmentsPortalProgress from './PlaylistAssignmentsPortalProgress';
import { useFilteredPlaylistAssignmentsPortals } from '../playlistAssignmentsHooks';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'academy-common-lib/utils/Styling';
import { TABLE_PAGINATOR_SIZE } from '../../table';
import MobileNestedMenu from '../../../components/Modals/FullScreenModal/MobileNestedMenu';
import { MenuRow } from '../../cardMenu/components/MobileCardMenu';
import { useState } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { AddIcon } from 'foundations-assets/icons/components/AddIcon';
import { VerticalMenuIcon } from 'foundations-assets/icons/components/VerticalMenuIcon';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import useToggle from 'academy-common-lib/hooks/useToggle';
import { Paginator } from 'foundations-components/transitional/components/Paginator';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const UnstyledButton = styled.button.withConfig({
  displayName: "PlaylistAssignmentsPortalsList__UnstyledButton",
  componentId: "sc-1eqk5ia-0"
})(["background:none;border:none;padding:0;margin:0;font:inherit;color:inherit;cursor:pointer;text-align:inherit;width:100%;"]);
const PlaylistAssignmentsPortalOptions = ({
  portal,
  onClick,
  isOpen,
  onOpenChange
}) => {
  return /*#__PURE__*/_jsx(MobileNestedMenu, {
    indented: false,
    open: isOpen,
    setIsOpen: onOpenChange,
    useBackText: true,
    useSidePanel: true,
    children: /*#__PURE__*/_jsx(MenuRow, {
      children: /*#__PURE__*/_jsxs(AssignPlaylistButton, {
        block: true,
        onClick: () => {
          if (onClick) onClick(portal);
        },
        playlistId: portal.playlistId,
        portalId: portal.portal.id,
        use: "unstyled",
        children: [/*#__PURE__*/_jsx(AddIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
          className: "m-left-2",
          message: "learningCenter.common.assign"
        })]
      })
    })
  });
};
const PlaylistAssignmentsPortalRow = ({
  portal,
  onRowClick,
  isLast
}) => {
  const {
    isShowing,
    show,
    hide
  } = useToggle();
  const handleOpenChange = () => {
    onRowClick === null || onRowClick === void 0 || onRowClick({
      portal
    });
  };
  return /*#__PURE__*/_jsxs(Flex, {
    backgroundColor: "fill-surface-default",
    borderBlockEndStyle: isLast ? 'solid' : 'none',
    borderBlockStartStyle: "solid",
    borderColor: "border-core-subtle",
    borderWidth: "100",
    "data-test-id": `row_${portal.portal.id}`,
    padding: "300",
    children: [/*#__PURE__*/_jsx(UnstyledButton, {
      onClick: handleOpenChange,
      children: /*#__PURE__*/_jsx(PlaylistAssignmentsPortalProgress, {
        portal: portal,
        showAssigneesCount: true
      })
    }), /*#__PURE__*/_jsx(IconButton, {
      onClick: show,
      use: "transparent",
      children: /*#__PURE__*/_jsx(VerticalMenuIcon, {})
    }), isShowing && /*#__PURE__*/_jsx(List, {
      wrapChildren: true,
      children: /*#__PURE__*/_jsx(PlaylistAssignmentsPortalOptions, {
        isOpen: isShowing,
        onOpenChange: hide,
        portal: portal
      })
    })]
  });
};
const PlaylistAssignmentsPortalsList = ({
  playlistId,
  onRowClick
}) => {
  const [page, setPage] = useState(1);
  const {
    playlistAssignmentsPortals,
    pageCount
  } = useFilteredPlaylistAssignmentsPortals({
    playlistId,
    page
  });
  if (!playlistAssignmentsPortals) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("section", {
      children: playlistAssignmentsPortals.map((portal, index) => /*#__PURE__*/_jsx(PlaylistAssignmentsPortalRow, {
        isLast: index === playlistAssignmentsPortals.length - 1,
        onRowClick: onRowClick,
        portal: portal
      }, `${playlistId}_${portal.portal.id}`))
    }), pageCount > 1 && /*#__PURE__*/_jsx(Paginator, {
      marginBlockStart: "300",
      maxVisiblePageButtons: TABLE_PAGINATOR_SIZE,
      onPageChange: ({
        target: {
          value
        }
      }) => setPage(value),
      page: page,
      pageCount: pageCount
    })]
  });
};
export default PlaylistAssignmentsPortalsList;